module.exports = __webpack_public_path__ + "static/img/kurogoki.9494cfa.jpg";